export default __webpack_public_path__ + "static/media/CrabPage1.91167f80.txt";